import { atom } from 'recoil';
export const transferTag = atom({
  key: 'transferTag',
  default: undefined
});
export const transferVehicle = atom({
  key: 'transferVehicle',
  default: undefined
});
export const vehicleInsuranceRegistration = atom({
  key: 'vehicleInsuranceRegistration',
  default: undefined
});
export const transferDepositAtom = atom({
  key: 'transferDepositAtom',
  default: true
});
export const changeVehicleAtom = atom({
  key: 'changeVehicleAtom',
  default: true
});